<template>
  <v-card>
    <v-app-bar
      class="defaultHeader"
      height="120"
      flat
      :clipped-left="$vuetify.breakpoint.lgAndUp"
    >
      <v-app-bar-nav-icon
        class="menu"
        @click="drawer = true"
      ></v-app-bar-nav-icon>
      <v-spacer class="shrink mr-10"></v-spacer>
      <v-spacer class="spacers" />
      <a href="https://www.ifsc.edu.br/inicio" title="Site do IFSC">
        <v-img
          alt="Ifsc"
          class="shrink mr-2"
          contain
          src="../../../../styles/assets/ifsc-logo.png"
          transition="scale-transition"
          width="50"
        />
      </a>
      <a href="https://www.epagri.sc.gov.br/" title="Site da Epagri">
        <v-img
          alt="Epagri"
          class="shrink mr-2"
          contain
          src="../../../../styles/assets/epagri-logo.png"
          transition="scale-transition"
          width="50"
        />
      </a>
      <a href="https://www.abpm.org.br" title="Site da ABPM">
        <v-img
          alt="Epagri"
          class="shrink mr-2"
          contain
          src="../../../../styles/assets/ABPM.png"
          transition="scale-transition"
          width="80"
        />
      </a>
      <v-spacer />
      <v-btn text rounded to="/" class="mr-5 inicio">Inicio</v-btn>
      <dropdown name="Informações" :items="information" class="informacao" />
      <dropdown name="Galeria" :items="gallery" class="galeria" />
      <v-btn text rounded class="mr-5 arquivos" to="/arquivos">Arquivos</v-btn>

      <v-spacer />
      <v-btn text rounded to="/login" class="login">Login</v-btn>

      <v-btn
        v-on:click="$vuetify.theme.dark = !$vuetify.theme.dark"
        @click="mod($vuetify.theme.isDark)"
        icon
        class="mr-2 ml-2"
      >
        <v-icon>mdi-brightness-6</v-icon>
      </v-btn>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" absolute temporary app>
      <v-list nav dense>
        <v-list-item-group v-model="group">
          <v-list-item to="/">
            <v-btn text rounded>Inicio</v-btn>
          </v-list-item>
          <v-list-item>
            <dropdown name="Informações" :items="information" />
          </v-list-item>
          <v-list-item>
            <dropdown name="Galeria" :items="gallery" />
          </v-list-item>
          <v-list-item to="/arquivos">
            <v-btn text rounded>Arquivos</v-btn>
          </v-list-item>
          <v-list-item to="/login">
            <v-btn text rounded>Login</v-btn>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </v-card>
</template>

<script>
export default {
  created() {
    var tema;
    if (localStorage.getItem("dark") == "true") {
      tema = true;
    } else {
      tema = false;
    }
    this.$vuetify.theme.dark = tema;
  },
  name: "defaultHeader",
  components: {
    dropdown: () => import("../dropdown/index.vue")
  },
  data: () => ({
    drawer: false,
    group: null,
    gallery: [
      {
        title: "Imagens",
        link: "/fotos"
      },
      {
        title: "Vídeos",
        link: "/videos"
      }
    ],
    information: [
      {
        title: "Cancro Europeu",
        link: "/cancro"
      },
      {
        title: "Medidas e Manejo",
        link: "/medidas"
      }
    ]
  }),
  methods: {
    mod(opcao) {
      localStorage.setItem("dark", opcao);
    }
  }
};
</script>

<style scoped>
@media only screen and (max-width: 836px) {
  .inicio {
    display: none;
  }
  .informacao {
    display: none;
  }
  .galeria {
    display: none;
  }
  .arquivos {
    display: none;
  }
  .login {
    display: none;
  }
}
@media only screen and (min-width: 837px) {
  .menu {
    display: none;
  }
  .spacers {
    display: none;
  }
}
</style>
